var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('MainLayout', {
    attrs: {
      "showNavigation": false
    }
  }, [_c('div', {
    staticClass: "device-check-wrapper d-flex flex-column align-center justify-center"
  }, [_c('h1', {
    staticClass: "device-check-title"
  }, [_vm._v("Are you on the device you'll use to record?")]), _c('v-alert', {
    staticClass: "mb-6 requirement-alert",
    attrs: {
      "type": "warning",
      "outlined": "",
      "dense": ""
    }
  }, [_vm._v(" Single device recording requires the OpenCap App Store app version 2.0 or newer. "), _c('a', {
    staticClass: "app-store-link",
    attrs: {
      "href": "https://apps.apple.com/us/app/opencap/id1630513242",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("Get it on the App Store")]), _vm._v(". ")]), _vm.isIosDevice ? _c('div', {
    staticClass: "options-container"
  }, [_c('div', {
    staticClass: "option-card pa-6 d-flex flex-column align-center",
    on: {
      "click": _vm.onThisDevice
    }
  }, [_c('v-icon', {
    staticClass: "mb-4 option-icon",
    attrs: {
      "size": "64"
    }
  }, [_vm._v("mdi-check-circle-outline")]), _c('div', {
    staticClass: "title-row mb-2"
  }, [_c('h2', {
    staticClass: "mb-0 option-title"
  }, [_vm._v("Yes, this device")])]), _c('p', {
    staticClass: "text-center option-description"
  }, [_vm._v(" I'll record using this phone. Set up the session here and open in the app. ")]), _c('v-btn', {
    staticClass: "mt-4 select-button",
    attrs: {
      "large": "",
      "loading": _vm.loading,
      "disabled": _vm.loading
    }
  }, [_vm._v(" Select ")])], 1), _c('div', {
    staticClass: "option-card pa-6 d-flex flex-column align-center",
    on: {
      "click": _vm.onDifferentDevice
    }
  }, [_c('v-icon', {
    staticClass: "mb-4 option-icon",
    attrs: {
      "size": "64"
    }
  }, [_vm._v("mdi-qrcode-scan")]), _c('div', {
    staticClass: "title-row mb-2"
  }, [_c('h2', {
    staticClass: "mb-0 option-title"
  }, [_vm._v("No, different device")])]), _c('p', {
    staticClass: "text-center option-description"
  }, [_vm._v(" I'll use a different phone to record. Show me a QR code to connect it. ")]), _c('v-btn', {
    staticClass: "mt-4 select-button",
    attrs: {
      "large": "",
      "loading": _vm.loading,
      "disabled": _vm.loading
    }
  }, [_vm._v(" Select ")])], 1)]) : _c('div', {
    staticClass: "non-ios-message mt-6"
  }, [_c('v-alert', {
    staticClass: "mb-4 non-ios-alert",
    attrs: {
      "type": "info",
      "outlined": "",
      "dense": ""
    }
  }, [_vm._v(" Monocular recording is supported on iPhone and iPad using the OpenCap app. You can open this page on a compatible iOS device, or set up the session here and scan the QR code with your phone to connect. Alternatively, use the multi-camera workflowi. ")]), _c('v-btn', {
    staticClass: "mt-2",
    on: {
      "click": _vm.onDifferentDevice
    }
  }, [_vm._v(" Set up session and show QR code ")])], 1), _c('v-btn', {
    staticClass: "device-check-back",
    attrs: {
      "text": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$router.push({
          name: 'RecordingMode'
        });
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-arrow-left")]), _vm._v(" " + _vm._s(_vm.backLabel) + " ")], 1)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }